@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../settings-page.module.less';

.grid-subcontainer() {
  display: grid;
  grid-template-columns: 3fr 4fr 2fr 140px;
  grid-template-rows: auto;
}

.grid-item() {
  display: flex;
  align-items: center;
  padding: @settings-page--table--cell--padding;
  overflow: hidden;
}

.grid-container {
  display: flex;
  flex-direction: column;
  border: @settings-page--table--border;
  font-size: @settings-page--table--font-size;
  line-height: @settings-page--table--line-height;
}

.grid-header {
  font-weight: @settings-page--table--header--cell--font-weight;
  border-bottom: @settings-page--table--border;
  .grid-subcontainer();

  .header-item {
    padding: 8px;

    .grid-item();
    background: @settings-page--table--header--cell--background-color;

    &:last-child {
      display: flex;
      justify-content: center;
    }
  }
}

.grid-row {
  .grid-subcontainer();
  border-bottom: @settings-page--table--border;
  background: @settings-page--table--body--cell--background-color;

  &:last-of-type {
    border-bottom: none;
  }

  &:hover {
    background: @settings-page--automation-order-filter-grid--hover--background-color;
  }

  .grid-item {
    .grid-item();

    &:last-child {
      display: flex;
      justify-content: center;

      svg {
        color: var(--default--text-color--3);
      }
    }
  }

  .actions {
    .grid-item();

    > :first-child {
      margin-right: 15px;
    }
  }
}

.truncated {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
